<ui-table-filter
  *ngIf="nzShowFilter || nzCustomFilter; else notFilterTemplate"
  [contentTemplate]="notFilterTemplate"
  [extraTemplate]="extraTemplate"
  [customFilter]="nzCustomFilter"
  [filterMultiple]="nzFilterMultiple"
  [listOfFilter]="nzFilters"
  (filterChange)="onFilterValueChange($event)"></ui-table-filter>
<ng-template #notFilterTemplate>
  <ng-template [ngTemplateOutlet]="nzShowSort ? sortTemplate : contentTemplate"></ng-template>
</ng-template>
<ng-template #extraTemplate>
  <ng-content select="[nz-th-extra]"></ng-content>
  <ng-content select="nz-filter-trigger"></ng-content>
</ng-template>
<ng-template #sortTemplate>
  <ui-table-sorters [sortOrder]="sortOrder" [sortDirections]="sortDirections" [contentTemplate]="contentTemplate"></ui-table-sorters>
</ng-template>
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
